import { AfterViewInit, Component } from '@angular/core';
import { ActivatedRoute, NavigationStart, Router } from '@angular/router';
import { delegate } from 'utils-decorators';
import { AutenticacaoService } from './services/autenticacao.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements AfterViewInit {

  rota!: string;

  constructor(
    private auth: AutenticacaoService,
    private router: Router,
    private route: ActivatedRoute,
  ) {
    // this.router.events.subscribe(res => //console.log("RES", res))

    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {

        this.rota = event.url;

        ////console.log(this.rota);
        if (!this.rota.startsWith("/bnb")) {
          const favicon = document.getElementById("favicon");
          favicon?.setAttribute("href", "../assets/icons/faviconCapfiador.png");
        } else {
          const favicon = document.getElementById("favicon");
          favicon?.setAttribute("href", "../assets/icons/faviconBnb.png");
        }

      }
    });
  }

  ngAfterViewInit(): void {
    this.carregarDados();

    // if (!environment.production)
    //   //console.log('tick')
  }

  @delegate()
  async carregarDados() {

    // TODO: Verificar favicon
    // if (ParceiroProvider.get() === 1) {
    //   const favicon = document.getElementById("favicon");
    //   favicon?.setAttribute("href", "../assets/icons/faviconBnb.png");
    // }



    // if(ParceiroProvider.get() === 17) {
    //   const favicon = document.getElementById("favicon");
    //   favicon?.setAttribute("href", "../assets/icons/faviconCapfiador.png");
    // }

    // TODO: tratar rota baseado na sigla no objeto do usuário

    // const rotaBnb = '/bnb';
    // const rotaCapfiador = '/capfiador';

    // const usuario = await this.auth.getUsuario();
    // if(usuario?.urlParceiro){
    //   this.router.navigate([`${usuario.urlParceiro}/venda`]);
    //   return;
    // }

    // if (usuario?.idParceiro !== ParceiroProvider.get()) {
    //   if (usuario?.idParceiro === 1)
    //     this.router.navigate([`${rotaBnb}/venda`])

    //   if (usuario?.idParceiro === 17)
    //     this.router.navigate([`${rotaCapfiador}/venda`])
    // }
  }

}
